import { API_CONFIG_V2 } from '../../config/api.v2.config';
import { QrCodeResponse } from '../../types/api.v2.types';
import { handleApiCallV2 } from './config';

export const uploadPhoto = async (
  fourCutImage: File,
  videos: File[],
  frameId: number,
  paymentId: string,
  logoUrl: string,
  color: string,
  retries: number = 2
): Promise<Blob> => {
  const formData = new FormData();
  formData.append('fourCutImage', fourCutImage);

  videos.forEach((video) => {
    formData.append('videos', video);
  });

  const requestDto = JSON.stringify({ frameId, paymentId, logoUrl, color });
  const requestDtoBlob = new Blob([requestDto], { type: 'application/json' });
  formData.append('requestDto', requestDtoBlob);

  try {
    const response = await handleApiCallV2<FormData, ArrayBuffer>(
      API_CONFIG_V2.ENDPOINTS.UPLOAD_PHOTO,
      formData,
      'POST',
      true,
      { responseType: 'arraybuffer' }
    );

    return new Blob([response.data], { type: 'image/png' });
  } catch {
    if (retries === 0) {
      throw new Error('QR코드 생성에 문제가 발생했어요.');
    }

    return uploadPhoto(fourCutImage, videos, frameId, paymentId, logoUrl, color, retries - 1);
  }
};

export const callAIModel = async (
  image: File,
  modelCode: string,
  blockId: number
): Promise<string> => {
  const formData = new FormData();
  formData.append('image', image);

  return handleApiCallV2<FormData, ArrayBuffer>(
    `${API_CONFIG_V2.ENDPOINTS.AI_MODEL}?aiModelCode=${modelCode}&blockId=${blockId}`,
    formData,
    'POST',
    true,
    { responseType: 'arraybuffer' }
  ).then((response) => {
    const blob = new Blob([response.data], { type: 'image/png' });
    return URL.createObjectURL(blob);
  });
};

export const getQrcode = async (qrId: string): Promise<QrCodeResponse> => {
  const res = await handleApiCallV2<null, QrCodeResponse>(
    `${API_CONFIG_V2.ENDPOINTS.GET_QR}/${qrId}`,
    null,
    'GET'
  );

  return res.data;
};

export const checkAiServer = async (themeId: number) => {
  await handleApiCallV2<{ themeId: number }, null>(
    `${API_CONFIG_V2.ENDPOINTS.AI_SERVER_CHECK}`,
    { themeId },
    'POST',
    true
  );
};

export const sendEmailAnalytics = async (email: string): Promise<void> => {
  await handleApiCallV2<string, null>(
    API_CONFIG_V2.ENDPOINTS.ANALYTICS_EMAIL,
    email,
    'POST',
    false,  // 토큰 없이 전송 가능하도록 변경
    { headers: { 'Content-Type': 'text/plain' } }
  );
};
